
type Competency = {
  key: string;
  label: string;
  color: string;
  details: Record<string, string>;
};

export const LEVELS = [
  "Early",
  "Developing",
  "Understanding",
  "Mature",
];


export const SOCIAL_COMPETENCIES:Competency[] = [
  {
    key: "selfAwareness",
    label: "Self Awareness",
    color: "#F5A623",
    details: {
      Early:
        "Does not yet name feelings; often overwhelmed by body signals without knowing why.",
      Developing:
        'Can name feelings and what causes them when calm or asked, but does not yet notice them in the moment.',
      Understanding:
        "Notices and names their feelings and triggers in the moment in familiar situations, sometimes with a prompt.",
      Mature:
        "Reflects on their emotions on their own and explains how they affect their behavior and others.",
    },
  },
  {
    key: "selfManagement",
    label: "Self Management",
    color: "#5DADE2",
    details: {
      Early:
        "Reacts impulsively; does not yet know a way to calm down or focus.",
      Developing:
        "Can name a calming strategy, such as deep breathing, but does not yet use it when upset.",
      Understanding:
        "Uses a calming strategy when reminded or in familiar situations.",
      Mature:
        "Uses calming strategies on their own, including in stressful moments.",
    },
  },
  {
    key: "socialAwareness",
    label: "Social Awareness",
    color: "#EB7E23",
    details: {
      Early:
        "Focuses on their own needs; does not yet notice how peers feel.",
      Developing:
        "Can say how a peer feels and why when asked, but does not yet respond to it.",
      Understanding:
        "Responds to peers' feelings and cues with little guidance, mostly with close friends.",
      Mature:
        "Shows empathy and curiosity about others' views without prompting, including with children they don't know well.",
    },
  },
  {
    key: "relationshipSkills",
    label: "Relationship Skills",
    color: "#17A65B",
    details: {
      Early:
        "Escalates conflict, blames others, or withdraws from peers.",
      Developing:
        'Knows what repairing a conflict looks like, such as saying sorry or using "I feel" words, but does not yet try it.',
      Understanding:
        "Tries to resolve conflicts and talks respectfully with close friends, sometimes with an adult's help.",
      Mature:
        "Collaborates, repairs relationships on their own, and helps peers resolve conflicts.",
    },
  },
  {
    key: "responsibleDecisionMaking",
    label: "Responsible Decision Making",
    color: "#E87BCF",
    details: {
      Early:
        "Makes impulsive choices; relies on the teacher for direction.",
      Developing:
        "Can explain the right choice and its consequences, but does not yet act on it unless supervised.",
      Understanding:
        "Makes positive choices on their own in familiar situations.",
      Mature:
        "Weighs their own needs with fairness to the group and decides responsibly across situations.",
    },
  },
];
